// Native
import { useCallback, useState } from "react"
import { useNavigate } from "react-router"
import { AdvancedMarker, APIProvider, CollisionBehavior, InfoWindow, Map, Pin, useAdvancedMarkerRef } from "@vis.gl/react-google-maps"

// Components
import { Avatar, Box, Button, Flex, Text } from "@chakra-ui/react"

// Hooks
import { useReport } from "hooks";


export default function DistributorsMap({ ...props }){

    const report = useReport('distributors_geolocation')

    return(
    <Box overflow="hidden" borderRadius={10} {...props}>
        <APIProvider apiKey="AIzaSyD0H9SsIRjE8mdlEKtPRRWElxzRzHtAqbg">
            <Map 
                mapId="6fa8a048972db694"
                style={{width: '100%', height: '550px', borderRadius: '10%' }}
                defaultCenter={{lat: -15.3529072, lng: -53.2130896 }}
                defaultZoom={5}
                gestureHandling={'greedy'}
                disableDefaultUI={true}
            >
                { report.data?.data?.map(item => <MapMarker data={item} />) }
                {/* { report.data?.data?.map(item => <Marker position={{ lat: parseFloat(item.lat), lng: parseFloat(item.lng) }} label={item.name.substr(0,1)} title={item.name} />) } */}
            </Map>
        </APIProvider>
    </Box>
    )
}

const MapMarker = ({ data, ...props }) => {

    const navigate = useNavigate()
    const [markerRef, marker] = useAdvancedMarkerRef()
    const [infoWindowShown, setInfoWindowShown] = useState(false)

    const handleMarkerClick = useCallback(() => setInfoWindowShown(isShown => !isShown), [])
    const handleClose = useCallback(() => setInfoWindowShown(false), [])

    const activeStyle = { background: 'orange', borderColor: 'orange', glyphColor: 'green' }
    const inactiveStyle = { background: 'red', borderColor: 'orange', glyphColor: 'orange' }
    const style = data.blocked_at ? inactiveStyle : activeStyle

    if(!data?.lat) return <></>

    return(
    <>
    <AdvancedMarker ref={markerRef} onClick={handleMarkerClick} position={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }} title={data.name.substr(0,1)} collisionBehavior={CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY}>
        <Pin {...style} />
    </AdvancedMarker>

    { infoWindowShown && (
        <InfoWindow anchor={marker} onClose={handleClose} headerContent={<Text color="#000" children={data.name} textAlign="left" fontWeight="bold" />} maxWidth={450}>
            <Flex alignItems="center" justifyContent="center">
                <Avatar name={data.name} />
                <Box maxW="200px" textAlign="left" mx={4}>
                    <Text color="#000" children={`${data.address_line_1} | ${data.address_number} | ${data.address_neighborhood} ${data.zip}`} />
                </Box>
                <Button colorScheme="orange" fontSize="xs" children="Visualizar núcleo" onClick={() => navigate(`/distributors/${data.id}`)} />
            </Flex>
        </InfoWindow>
    )}
    </>
)}